import { render, staticRenderFns } from "./cargoOwnerMfeAction.vue?vue&type=template&id=bedae96a&scoped=true"
import script from "./cargoOwnerMfeAction.vue?vue&type=script&lang=js"
export * from "./cargoOwnerMfeAction.vue?vue&type=script&lang=js"
import style0 from "./cargoOwnerMfeAction.vue?vue&type=style&index=0&id=bedae96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedae96a",
  null
  
)

export default component.exports